<template>
  <div class="row-fluid">
    <div class="container">
      <div class="row">
        <div class="col-lg-5 col-md-6 col-sm-6 col-xs-12 newAddress">
          <h3>
            {{ labels[1044] }}
            <!-- Shipping address for this order: -->
          </h3>
          <div id="addressForm">
            <template v-if="loadingAddressForm">
              <h3 class="loadingText">
                <img src="/layouts/main/styles/images/spinner.gif" />
                Loading
              </h3>
              <div class="loadingOverlay"></div>
            </template>

            <Checkout-Address-Form mode="shipping" />
          </div>
        </div>
        <div class="col-lg-offset-2 col-lg-5 col-md-6 col-sm-6 col-xs-12 add-list">
          <Checkout-Address-Selector mode="shipping" />
        </div>
        <div class="col-lg-5 col-md-6 col-sm-6 col-xs-12" v-if="!canContinue">
          <div class="alert alert-warning">
            <strong>{{ labels[2468] }}</strong>
            {{ labels[2571] }}
          </div>
          <button class="btn btn-primary btn-block btn-continue" @click="useAddressAsIs()">
            USE ADDRESS AS IS
            <span>&rsaquo;</span>
            <!-- USE ADDRESS AS IS -->
          </button>
        </div>
      </div>
      <hr />

      <cart-footer>
        <template v-slot:left>
          <div v-html="labels[1306]"></div>
          <div class="alert alert-warning">
            <strong>Note:</strong>
            Our ordering process has changed. After placing your order, an order technician will
            contact you to complete your purchase.
          </div>
        </template>
        <!-- label: Note: For tax and accounting purposes, a shipping address is required... -->
        <template v-slot:center>{{ labels[1061] }}</template>
        <!-- Tax and Shipping will be added on the next screen. -->
        <template v-slot:right>
          <div class="priceDisplayBox">
            <Checkout-Total-Box />
          </div>
          <button
            rel="nofollow"
            :disabled="!canContinue"
            :class="continueBtnClass"
            class="btn btn-primary btn-block btn-continue"
            @click="proceedToNextStep"
            id="ship-address-next-vue"
          >
            {{ labels[1060] }}
            <span>&rsaquo;</span>
            <!-- CONTINUE -->
          </button>
        </template>
      </cart-footer>
    </div>
  </div>
</template>

<script>
  import { computed } from '@vue/composition-api'
  import router from '../router'
  import useCMS from '../../shared/composables/useCMS'
  import useCheckout from '../composables/useCheckout'
  import useCheckoutAddresses from '../composables/useCheckoutAddresses'
  import CheckoutAddressForm from '../components/CheckoutAddressForm.vue'
  import CheckoutTotalBox from '../components/CheckoutTotalBox.vue'
  import CheckoutAddressSelector from '../components/CheckoutAddressSelector.vue'
  import CartFooter from '../components/CartFooter'

  export default {
    name: 'Checkout',
    components: {
      CheckoutAddressForm,
      CheckoutTotalBox,
      CheckoutAddressSelector,
      CartFooter,
    },
    setup() {
      const { labels } = useCMS()
      const { loadingAddressForm, invalidAddress } = useCheckoutAddresses()
      let { proceedToNextStep, canContinue, continueBtnClass } = useContinueToShipMethodBtn()

      const useAddressAsIs = () => {
        invalidAddress.value = false
        return true
      }

      return {
        labels,
        canContinue,
        continueBtnClass,
        loadingAddressForm,
        invalidAddress,
        useAddressAsIs,
        proceedToNextStep,
      }
    },
  }

  function useContinueToShipMethodBtn() {
    const { addresses } = useCheckout()
    const { editingAddress, addressErrors, invalidAddress } = useCheckoutAddresses()

    if (addresses.value.shipping.VALID === undefined) {
      addresses.value.shipping.VALID = addressErrors(addresses.value.shipping).length == 0
    }

    const canContinue = computed(
      () =>
        !isNaN(addresses.value.shipping.ID) &&
        addresses.value.shipping.ID > 0 &&
        !editingAddress.value &&
        addresses.value.shipping.VALID &&
        !invalidAddress.value
    )

    const continueBtnClass = computed(() => (!canContinue.value ? 'disable' : ''))

    const proceedToNextStep = () => {
      if (canContinue.value) {
        router.push('/checkout/ship-method')
        //send axios for processing ship tax and then push router to next step if success
      } else {
        alert('Unable to proceed to next step')
      }
    }
    return {
      proceedToNextStep,
      canContinue,
      continueBtnClass,
    }
  }
</script>
